import { schCompType } from '@aloft/toolkit-shared';
import { Flex, Icon, RadioGroup, Select, Tooltip, Typography } from '@aloft/toolkit-sui';

import { Controller, FormProvider } from 'react-hook-form';

import { AddressInput } from '../../../../../components/AddressInput/AddressInput.tsx';
import {
  selectHasArvOption,
  selectPropertyType,
} from '../../../../../redux/features/selectors/orderSelectors.ts';
import { useAppSelector } from '../../../../../redux/hooks.ts';
import { getPropertyTypeOptions } from '../getPropertyTypeOptions.ts';
import { AddCompsFormProps } from '../types.ts';

export const AddCompsForm = ({ form }: AddCompsFormProps) => {
  const hasArvOption = useAppSelector(selectHasArvOption);
  const primaryPropertyType = useAppSelector(selectPropertyType) ?? 'singleFamilyResidence';
  const propertyTypeOptions = getPropertyTypeOptions({
    primaryPropertyType,
  });

  return (
    <Flex width="100%" height="100%" gap={3} flexDirection="column">
      <FormProvider {...form}>
        <Flex>
          <Typography variant="h3">Add Comparable</Typography>
          <Tooltip label="Toolkit will import data from your MLS and/or county records to autofill certain fields. You can still edit these fields.">
            <Flex marginLeft={1}>
              <Icon size="sm" icon="question" color="textSecondary" />
            </Flex>
          </Tooltip>
        </Flex>
        <Flex gap={3} flexDirection="column">
          <AddressInput />
          <Controller
            control={form.control}
            key="propertyType"
            name="propertyType"
            defaultValue={primaryPropertyType}
            render={({ field }) => (
              <Select
                isRequired
                label="Property Type"
                {...field}
                options={propertyTypeOptions}
                onChange={(val) => {
                  field.onChange(val ?? 'singleFamilyResidence');
                }}
              />
            )}
          />
        </Flex>
        {hasArvOption && (
          <Controller
            control={form.control}
            key="compType"
            name="compType"
            render={({ field }) => (
              <RadioGroup
                isRequired
                label="Valuation Type"
                size="lg"
                forceHorizontal
                columnGap="2rem"
                items={[
                  { label: 'As-Is Value', value: schCompType.enum.aiv },
                  { label: 'After Repair Value', value: schCompType.enum.arv },
                ]}
                value={field.value}
                onChange={field.onChange}
              />
            )}
          />
        )}
      </FormProvider>
    </Flex>
  );
};
